
<ElFormItem
    v-if="!insetHide"
    :class="`condition-item condition-item--input-number condition-item--${field} condition-item--${!!postfix}`"
    v-bind="formItemProps"
    :prop="formItemProps.prop || field"
>
    <!-- 不监听回车事件, 防止实际值与组件内部的值(会根据提供的精度等配置项而主动改变)不匹配 -->
    <!-- @keydown.enter="enterHandle" -->
    <ElInputNumber
        v-bind="contentProps"
        :disabled="insetDisabled"
        :value="checked === 0 ? 0 : checked || undefined"
        class="condition-item__content"
        @input="debounceChange"
    ></ElInputNumber>
    <div v-if="postfix" class="condition-item__postfix">
        <template v-if="typeof postfix === 'string'">{{ postfix }}</template>
        <template v-else>
            <component :is="getNode(postfix, checked)"></component>
        </template>
    </div>
</ElFormItem>
